function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FLEXIBLE_GRID_CARD_CLICKED } from "/constants/bigbrain-event-types";
import GridImage from "segments/desktop/core-components/grid-image/grid-image";
import classnames from "classnames";
import Colors from "/styles/colors";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { trackEvent } from "/services/bigbrain-service";
import { StyledGridParagraphWithImage } from "./grid-paragraph-with-image.scss";
import DefaultProps from "./default-props";
import { hexToRgba } from "utils/general";
import PictureComponent from "components/core/picture/picture-component";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
const GridParagraphWithImage = (props)=>{
    const { borderColor, showParagraph, fullParagraph, titleSize, textSize, cardTagText, contentVerticalAlignment, paragraphVerticalColoredLineColor, padding, backgroundImage, cardColor, borderOpacity, cardWidthForCss, disableHoverStyle, footer, imageOnTop, link } = props;
    const { url: buttonUrl, isOpenLinkInNewTab, buttonText } = (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.buttonConfig) || {};
    const url = buttonUrl || (link === null || link === void 0 ? void 0 : link.href) || (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.href);
    const shouldOpenInNewTab = isOpenLinkInNewTab || (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.isNewTab);
    const handleClick = ()=>{
        trackEvent(FLEXIBLE_GRID_CARD_CLICKED, {
            kind: buttonText,
            info1: fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.title,
            info2: url
        });
        url && window.open(url, shouldOpenInNewTab ? "_blank" : "_self");
    };
    const getParagraphStyle = ()=>{
        return {
            padding
        };
    };
    const getStyle = ()=>{
        const color = Colors[cardColor];
        const borderRgbaColor = borderColor === Colors.transparent ? borderColor : borderColor && hexToRgba(Colors[borderColor], parseFloat(borderOpacity) || 1);
        let style = {
            backgroundColor: color,
            maxWidth: cardWidthForCss,
            border: `1px solid ${borderRgbaColor}`
        };
        if (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) {
            style = _object_spread_props(_object_spread({}, style), {
                backgroundImage: `url(${backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.backgroundPosition) || "center"
            });
        }
        return style;
    };
    const renderParagraph = ()=>{
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: showParagraph && /*#__PURE__*/ _jsxs("div", {
                className: classnames("grid-paragraph-wrapper"),
                style: getParagraphStyle(),
                children: [
                    /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({
                        titleSize: titleSize,
                        textSize: textSize
                    }, fullParagraph), {
                        paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor
                    })),
                    (footer === null || footer === void 0 ? void 0 : footer.showFooter) && /*#__PURE__*/ _jsxs("div", {
                        className: "footer",
                        children: [
                            (footer === null || footer === void 0 ? void 0 : footer.image) && /*#__PURE__*/ _jsx(PictureComponent, {
                                className: "footer-image",
                                src: footer === null || footer === void 0 ? void 0 : footer.image
                            }),
                            /*#__PURE__*/ _jsx(MondayMarkupLanguageComponent, {
                                className: "footer-text",
                                text: footer === null || footer === void 0 ? void 0 : footer.text
                            })
                        ]
                    })
                ]
            })
        });
    };
    const renderComponent = ()=>{
        const { shadowCards, removeShadowOnHover, src, cardTagColor } = props, restImageProps = _object_without_properties(props, [
            "shadowCards",
            "removeShadowOnHover",
            "src",
            "cardTagColor"
        ]);
        const tagColor = Colors[cardTagColor];
        return /*#__PURE__*/ _jsxs("div", {
            className: classnames("grid-paragraph-with-image", {
                shadow: shadowCards,
                "without-shadow-hover": removeShadowOnHover
            }, contentVerticalAlignment),
            style: getStyle(),
            children: [
                cardTagText && /*#__PURE__*/ _jsx("div", {
                    className: "tag",
                    style: {
                        borderColor: tagColor,
                        color: tagColor
                    },
                    children: cardTagText
                }),
                imageOnTop && src && /*#__PURE__*/ _jsx("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ _jsx(GridImage, _object_spread({
                        src: src
                    }, restImageProps))
                }),
                renderParagraph(),
                !imageOnTop && src && /*#__PURE__*/ _jsx("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ _jsx(GridImage, _object_spread({
                        src: src
                    }, restImageProps))
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx(StyledGridParagraphWithImage, {
        className: classnames("card-grid-link", {
            "without-link": !url,
            "disabled-hover-effect": disableHoverStyle
        }),
        onClick: handleClick,
        rel: "noreferrer",
        footerImageWidth: footer === null || footer === void 0 ? void 0 : footer.imageWidth,
        children: renderComponent()
    });
};
GridParagraphWithImage.defaultProps = _object_spread({}, DefaultProps);
export default GridParagraphWithImage;
